import type { FC, RefObject } from 'react';
import StoreListItem from './StoreListItem';
import type { AvailableQuantityItem, StoreListEntry } from '../types';

interface StoreListViewProps {
  shops: StoreListEntry[];
  selectedId: number;
  onSelect: (id: number) => void;
  elRefs?: Array<RefObject<HTMLDivElement>>;
  isShowAvailableQuantity?: boolean;
  availableQuantity?: AvailableQuantityItem[];
  availableLabelPrefix?: string;
}

/**
 * Single source of truth for the pickup store list. Wires `elRefs` to each
 * item so useListScrollIntoView can scroll the active store into view.
 */
const StoreListView: FC<StoreListViewProps> = ({
  shops,
  selectedId,
  onSelect,
  elRefs,
  isShowAvailableQuantity,
  availableQuantity,
  availableLabelPrefix
}) => (
  <div className='list custom-scroll'>
    {shops?.map((item, index) => (
      <StoreListItem
        key={item.id}
        ref={elRefs?.[index]}
        item={item}
        selected={item.id === selectedId}
        onSelect={() => {
          onSelect(item.id);
        }}
        isShowAvailableQuantity={isShowAvailableQuantity}
        availableQuantity={availableQuantity}
        availableLabelPrefix={availableLabelPrefix}
      />
    ))}
  </div>
);

export default StoreListView;
